import api from "./api";
import auth from "./auth";

const getBranches = () => {
    return new Promise((resolve, reject) => {
        api.get("organization-service/branch/list", auth.getHeader())
            .then(response => resolve(response))
            .catch(e => reject(e.errors));
    });
};

const create = payload => {
    return new Promise((resolve, reject) => {
        api.post(
            "organization-service/branch/create",
            payload,
            auth.getHeader()
        )
            .then(response => resolve(response))
            .catch(e => reject(e.errors));
    });
};

const tagProductsToBranch = param => {
    return new Promise((resolve, reject) => {
        api.get(
            "estore-service/v1/cms/estore/product/brand/in-queue/"+param,
            auth.getHeader()
        )
            .then(response => resolve(response))
            .catch(e => reject(e.errors));
    });
};

const update = (id, payload) => {
    return new Promise((resolve, reject) => {
        api.post(
            "organization-service/branch/update/" + id,
            payload,
            auth.getHeader()
        )
            .then(response => resolve(response))
            .catch(e => reject(e.errors));
    });
};

const view = id => {
    return new Promise((resolve, reject) => {
        api.get("organization-service/branch/view/" + id, auth.getHeader())
            .then(response => resolve(response))
            .catch(e => reject(e.errors));
    });
};

const doDelete = id => {
    return new Promise((resolve, reject) => {
        api.delete("organization-service/branch/delete/" + id, auth.getHeader())
            .then(response => resolve(response))
            .catch(e => reject(e.errors));
    });
};

const importCSV = file => {
    return new Promise((resolve, reject) => {
        let header = auth.getHeader();
        let formData = new FormData();
        formData.append("file", file, file.name);

        header["Content-Type"] = "multipart/form-data";
        api.post("organization-service/branch/import", formData, header)
            .then(response => resolve(response))
            .catch(e => reject(e.errors));
    });
};

const branchTableList = payload => {
    return new Promise((resolve, reject) => {
        api.post(
            "organization-service/branch/table/list",
            payload,
            auth.getHeader()
        )
            .then(response => resolve(response))
            .catch(e => reject(e.errors));
    });
};

const branchTableCreate = payload => {
    return new Promise((resolve, reject) => {
        api.post(
            "organization-service/branch/table/create",
            payload,
            auth.getHeader()
        )
            .then(response => resolve(response))
            .catch(e => reject(e.errors));
    });
};

const viewAdvanceSettings = (id, payload) => {
    return new Promise((resolve, reject) => {
        api.post(
            "organization-service/settings/view/" + id,
            payload,
            auth.getHeader()
        )
            .then(response => resolve(response))
            .catch(e => reject(e.errors));
    });
};

const updateAdvanceSettings = (id, payload) => {
    return new Promise((resolve, reject) => {
        api.post(
            "organization-service/v2/settings/update/" + id,
            payload,
            auth.getHeader()
        )
            .then(response => resolve(response))
            .catch(e => reject(e.errors));
    });
};

export default {
    getBranches,
    create,
    update,
    view,
    delete: doDelete,
    importCSV,
    branchTableList,
    branchTableCreate,
    viewAdvanceSettings,
    updateAdvanceSettings,
    tagProductsToBranch
};
